window.jQuery = window.$ = require('jquery');
var processInclude = require('./util');

document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-submit-on-change]') && e.target.form) {
        e.target.form.submit();
    }
});

$(document).ready(function () {
    processInclude(require('./components/sidebar'));
    processInclude(require('./components/quantitySelector'));
    processInclude(require('./searchJs'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/cart'));
    processInclude(require('./components/spinner'));
    processInclude(require('./components/uiComponents'));
    processInclude(require('./carouselJs'));
});
require('bootstrap');
